import React, { useState, useCallback } from 'react';
import { Row, Col } from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import * as dashboardActions from '../../store/dashboard/actions';

// Pages Components
import WelcomeBoxWide from '../../components/Dashboard/WelcomeBoxWide';
import MainMetrics from '../../components/Dashboard/MainMetrics';
import LeadMetrics from '../../components/Dashboard/LeadMetrics';
import MonetizationItemsInsights from '../../components/Dashboard/MonetizationItemsInsights';
import RevenuesGraph from '../../components/Dashboard/RevenuesGraph';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DateRangeFilter from '../../components/Common/DateRangeFilter/DateRangeFilter';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const AdminDashboard = (props) => {
  const startDate = useSelector((state) => state.Dashboard.startDate);
  const endDate = useSelector((state) => state.Dashboard.endDate);
  const filters = useSelector((state) => state.Dashboard.filters);
  const momentStartDate = startDate ? moment(startDate) : null;
  const momentEndDate = endDate ? moment(endDate) : null;

  const [selectedFilters, setSelectedFilters] = useState({
    startDate: momentStartDate || moment.utc().startOf('day'),
    endDate: momentEndDate || moment.utc(),
    sector: filters?.sector || '',
    campaignIds: filters?.campaignIds || null,
  });

  const dispatch = useDispatch();

  const refresh = useCallback(({ startDate, endDate, sector, campaignIds }) => {
    const selectedStartDate = startDate.utc().startOf('day').toDate();
    const selectedEndDate = endDate.utc().endOf('day').toDate();
    dispatch(
      dashboardActions.setFilters(selectedStartDate, selectedEndDate, {
        sector,
        campaignIds,
      }),
    );
    setSelectedFilters({ startDate, endDate, sector, campaignIds });
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs
        title={t('Dashboard')}
        onRefresh={() => refresh(selectedFilters)}
        loading={false}
      />
      <Row>
        <Col md="12" className="d-none d-sm-block">
          <WelcomeBoxWide />
        </Col>
      </Row>
      <DateRangeFilter
        onUpdate={refresh}
        startDate={selectedFilters.startDate}
        endDate={selectedFilters.endDate}
        loading={false}
        showFilters
        initialFilters={selectedFilters}
      />
      <Row>
        <LeadMetrics />
      </Row>
      <Row>
        <Col md="3">
          <MainMetrics filters={selectedFilters} />
        </Col>
        <Col md="9" className="d-none d-sm-block">
          <RevenuesGraph dateRange={selectedFilters} />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <MonetizationItemsInsights />
        </Col>
      </Row>
    </>
  );
};

export default AdminDashboard;
